import React from "react";
import { ReactComponent as ChatIcon } from "../../icons/bxs_chat.svg";
import { ReactComponent as CloseIcon } from "../../icons/CloseIcon.svg";
import { SearchFilterOptionType } from "../../data/types";
import { MessageModal } from "../../molecules/Mobile/AppModal";


type MessagesProps = {
  username: string
  searchFilterOptions: SearchFilterOptionType
  isOpen: boolean
  setIsOpen: React.Dispatch<React.SetStateAction<boolean>>
}

const Messages: React.FC<MessagesProps> = ({username, searchFilterOptions, isOpen, setIsOpen}) => {
  const { setSignInModalIsOpen, messageCommunityId, setMessageCommunityId } = searchFilterOptions
  return (
    <div>
      {!isOpen ? (
        <div className="fixed bottom-4 right-4 sm:bottom-6 sm:right-6 md:bottom-10 md:right-10 z-[100]">
          <button 
            className="flex flex-row items-center gap-3 w-auto min-w-[240px] sm:min-w-[270px] h-[64px] sm:h-[74px] px-4 py-3 cursor-pointer border-0 shadow-lg hover:shadow-xl bg-white rounded-2xl transition-all duration-200 active:scale-95" 
            onClick={() => {
              if (username){
                setIsOpen(true)
              } else {
                setSignInModalIsOpen(true)
              }
            }}
          >
            <div className="flex-shrink-0 w-10 h-10 sm:w-12 sm:h-12 p-2 bg-primaryDark-0 rounded-xl flex items-center justify-center">
              {/* <img
                src={messages}
                alt="Chat Icon"
                className="w-full h-full object-contain"
              /> */}
              <ChatIcon className="cursor-pointer w-full h-full object-contain" />
            </div>
            <div className="flex flex-col text-start flex-1 min-w-0">
              <div className="text-primaryDark-0 font-semibold text-sm sm:text-base font-raleway">Need Help?</div>
              <div className="text-[#4D4D4D] italic text-xs sm:text-sm font-open-sans truncate">
                Tap here to chat
              </div>
            </div>
          </button>
        </div>
      ) : (
        <div className="fixed bottom-4 right-4 sm:bottom-6 sm:right-6 md:bottom-10 md:right-10 z-[100]">
          <button 
            className="flex flex-row items-center gap-3 w-auto min-w-[240px] sm:min-w-[270px] h-[64px] sm:h-[74px] px-4 py-3 cursor-pointer border-0 shadow-lg hover:shadow-xl bg-white rounded-2xl transition-all duration-200 active:scale-95" 
            onClick={() => setIsOpen(false)}
          >
            <div className="flex-shrink-0 w-10 h-10 sm:w-12 sm:h-12 p-2 bg-primaryDark-0 rounded-xl flex items-center justify-center">
              {/* <img
                src={messages}
                alt="Chat Icon"
                className="w-full h-full object-contain"
              /> */}
              <CloseIcon className="cursor-pointer w-full h-full object-contain" />
            </div>
            <div className="flex flex-col text-start flex-1 min-w-0">
              <div className="text-primaryDark-0 font-bold text-sm sm:text-base font-raleway">Close</div>
              <div className="text-text-300 italic text-xs sm:text-sm font-open-sans truncate">
                Not what you needed?
              </div>
            </div>
          </button>
        </div>
      )}
      <MessageModal
        isOpen={isOpen}
        setIsOpen={setIsOpen}
        initialCommunityId={messageCommunityId}
        onClearInitialCommunity={() => setMessageCommunityId(undefined)}
      />
    </div>
  );
};

export default Messages;
